/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Grid, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { setBofuTabPropietarioDocument, setCurrentOwnerId } from "@store/slices/bofuSlice";
import TabBofu from "@components/TabBofu/TabBofu";
import { PersonaStructure } from "@interfaces/index";
import { InactivityHandler } from "@components/InactivityHandler";
import { BOFU_TABS_CONFIG } from "@helpers/constantes";
import ButtonExpedienteStatus from "@components/ButtonExpedienteStatus";
import { BofuTabPropietario } from "@interfaces/response";
import CustomRightImage from "@components/CustomRightImagev2";
import DocumentsTabBofu from "@components/TabBofu/DocumentsTabBofu";
import ButtonContinue from "@components/TabBofu/ButtonContinue";
import { CustomCompanyName } from "@components/CustomCompanyName";

const PropietarioRealPM: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const bufuLoading = useSelector((state: RootState) => state.bofu.isLoading);
  const bofuTabsObj = useSelector((state: RootState) => state.bofu.bofu_tabs_obj);

  const handleClickButtonExpedient = (propietario: PersonaStructure) => {
    dispatch(setCurrentOwnerId(propietario.id));
    setTimeout(() => {
      navigate("/producto/creditosimple/datos_propietario_real_1");
    }, 200);
  };

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <Box textAlign={"center"} mx={4}>
          <InactivityHandler />

          <CustomCompanyName />

          <TabBofu />

          {bufuLoading ? (
            <Box mt={3}>
              <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
            </Box>
          ) : (
            <Box>
              {bofuTabsObj.propietarios_reales.propietarios.length === 0 && (
                <Typography
                  color={theme?.palette?.primary?.dark}
                  fontSize={"20px"}
                  textAlign={"center"}
                  fontWeight={600}
                >
                  No se encontraron propietarios registrados
                </Typography>
              )}

              <Typography
                mt={4}
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={700}
                color={theme?.palette?.primary?.dark}
              >
                Ahora llena los formatos relacionados al o los propietarios reales
              </Typography>

              {bofuTabsObj.propietarios_reales.propietarios.map(
                (propietarioItem: BofuTabPropietario, index: number) => (
                  <Box key={index} mt={3}>
                    <Typography
                      mt={2}
                      variant={isMobileOrTablet ? "body2" : "body1"}
                      color={theme?.palette?.primary?.main}
                    >
                      Propietario real {index + 1}:{" "}
                      {`${propietarioItem.persona.name || ""} ${propietarioItem.persona.last_name || ""} ${
                        propietarioItem.persona.last_name_2 || ""
                      }`}
                    </Typography>

                    {propietarioItem.show_information_form && (
                      <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                        <Typography
                          variant="body1"
                          sx={{ flex: 1, textAlign: "left" }}
                          color={theme?.palette?.primary?.dark}
                        >
                          Información del propietario real
                        </Typography>

                        <ButtonExpedienteStatus
                          mode="form"
                          formStatus={propietarioItem.persona.personal_information_status || null}
                          onClick={() => handleClickButtonExpedient(propietarioItem.persona)}
                        />
                      </Box>
                    )}

                    <DocumentsTabBofu
                      inputPrefix={`propietario_${index}`}
                      tabCode={BOFU_TABS_CONFIG.tab_propietario.code}
                      documents={propietarioItem.documents || []}
                      onChange={({ document, newValue }) => {
                        dispatch(
                          setBofuTabPropietarioDocument({
                            document,
                            newValue,
                            persona: propietarioItem.persona,
                            valueAction: undefined,
                            valueIndex: undefined,
                          }),
                        );
                      }}
                      onChangeMultiple={({ document, newValue, valueAction, valueIndex }) => {
                        dispatch(
                          setBofuTabPropietarioDocument({
                            document,
                            newValue,
                            persona: propietarioItem.persona,
                            valueAction: valueAction || undefined,
                            valueIndex,
                          }),
                        );
                      }}
                    />
                  </Box>
                ),
              )}

              <Box mt={4}>
                <ButtonContinue tabCode={BOFU_TABS_CONFIG.tab_propietario.code} />
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default PropietarioRealPM;
